export const HEALTH_CHECK_INDICATOR_DEFINITIONS_COLLECTION_NAME =
  'health_check_indicator_definitions';
export const HEALTH_CHECK_INDICATORS_COLLECTION_NAME =
  'health_check_indicators';
export const HEALTH_CHECK_NOTIFICATIONS_COLLECTION_NAME =
  'health_check_notifications';
